// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-edit-settings .fi-publication-settings-container {
  width: 100%;
  margin-bottom: 20px;
}
.fi-form-edit-settings .fi-publication-settings-container .fi-page-collapsable-content-title {
  margin-bottom: 5px;
}
.fi-form-edit-settings .fi-publication-settings-container .subtitle-text-item {
  display: inline-block;
  font-size: 14px;
  line-height: 14px;
}
.fi-form-edit-settings .fi-publication-settings-container .subtitle-text-item:not(:first-child) {
  padding-left: 4px;
}
.fi-form-edit-settings .fi-publication-settings-container .subtitle-text-item:not(:last-child) {
  border-right: 1px solid;
  padding-right: 5px;
}
.fi-form-edit-settings .fi-publication-settings-container .block-element {
  display: block;
}
.fi-form-edit-settings .fi-publication-settings-container .mat-mdc-checkbox,
.fi-form-edit-settings .fi-publication-settings-container .mat-mdc-radio-button {
  margin-bottom: 7px;
}
.fi-form-edit-settings .fi-publication-settings-container .fi-access-right-filters .mat-mdc-checkbox,
.fi-form-edit-settings .fi-publication-settings-container .fi-access-right-filters .mat-mdc-radio-button {
  margin-bottom: unset;
}
.fi-form-edit-settings .fi-publication-settings-container .block-pad-left {
  padding: 0 15px;
}
.fi-form-edit-settings .fi-publication-settings-container .block-with-top-margin {
  margin-top: 20px;
}
.fi-form-edit-settings .fi-publication-settings-container .section-header {
  margin-bottom: 15px;
}
.fi-form-edit-settings .fi-publication-settings-container .publications-dates-select {
  margin-top: 10px;
}
.fi-form-edit-settings .Ccm-Page {
  padding: 0;
}
.fi-form-edit-settings .mat-mdc-card.content-margin {
  padding: 30px;
  max-width: 850px;
  width: 100%;
  margin: 20px auto;
  height: fit-content;
}
.fi-form-edit-settings .mat-mdc-card.content-margin .settings-email-sharing {
  margin-top: 25px;
}
.fi-form-edit-settings .mat-mdc-card.content-margin .settings-email-sharing .full-width-form-field .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-shared-styles/fi-publication-settings-mixin.scss","webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit-settings/fi-form-edit-settings.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,mBAAA;ACAR;ADCQ;EACI,kBAAA;ACCZ;ADCQ;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;ACCZ;ADAY;EACI,iBAAA;ACEhB;ADAY;EACI,uBAAA;EACA,kBAAA;ACEhB;ADCQ;EACI,cAAA;ACCZ;ADCQ;;EAEI,kBAAA;ACCZ;ADEY;;EAEI,oBAAA;ACAhB;ADGQ;EACI,eAAA;ACDZ;ADGQ;EACI,gBAAA;ACDZ;ADGQ;EACI,mBAAA;ACDZ;ADGQ;EACI,gBAAA;ACDZ;ADII;EACI,UAAA;ACFR;AAvCI;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAyCR;AAvCQ;EACI,gBAAA;AAyCZ;AAtCgB;EACI,WAAA;AAwCpB","sourcesContent":["@mixin fi-publication-settings-container {\r\n    .fi-publication-settings-container {\r\n        width: 100%;\r\n        margin-bottom: 20px;\r\n        .fi-page-collapsable-content-title {\r\n            margin-bottom: 5px;\r\n        }\r\n        .subtitle-text-item {\r\n            display: inline-block;\r\n            font-size: 14px;\r\n            line-height: 14px;\r\n            &:not(:first-child) {\r\n                padding-left: 4px;\r\n            }\r\n            &:not(:last-child) {\r\n                border-right: 1px solid;\r\n                padding-right: 5px;\r\n            }\r\n        }\r\n        .block-element {\r\n            display: block;\r\n        }\r\n        .mat-mdc-checkbox,\r\n        .mat-mdc-radio-button {\r\n            margin-bottom: 7px;\r\n        }\r\n        .fi-access-right-filters {\r\n            .mat-mdc-checkbox,\r\n            .mat-mdc-radio-button {\r\n                margin-bottom: unset;\r\n            }\r\n        }\r\n        .block-pad-left {\r\n            padding: 0 15px;\r\n        }\r\n        .block-with-top-margin {\r\n            margin-top: 20px;\r\n        }\r\n        .section-header {\r\n            margin-bottom: 15px;\r\n        }\r\n        .publications-dates-select {\r\n            margin-top: 10px;\r\n        }\r\n    }\r\n    .Ccm-Page {\r\n        padding: 0;\r\n    }\r\n}\r\n","@use '../../../shared/fi-shared-styles/fi-publication-settings-mixin.scss';\r\n\r\n.fi-form-edit-settings {\r\n    @include fi-publication-settings-mixin.fi-publication-settings-container();\r\n\r\n    .mat-mdc-card.content-margin {\r\n        padding: 30px;\r\n        max-width: 850px;\r\n        width: 100%;\r\n        margin: 20px auto;\r\n        height: fit-content;\r\n\r\n        .settings-email-sharing {\r\n            margin-top: 25px;\r\n\r\n            .full-width-form-field {\r\n                .mat-mdc-form-field {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
